import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Sidebar.css";

const Sidebar = ({ isOpen, onItemClick }) => {
  const [activeSection, setActiveSection] = useState("");
  const navigate = useNavigate();
  // const registrationNo = localStorage.getItem("registrationNo");
  const assessment_id = localStorage.getItem("assessment_id");

  const sections = [
    //  { id: "view-user-profile", name: "View/edit profile" },
    { id: "take-assessment", name: "Take assessment" },
    // { id: "Apply-for-certificate", name: "Apply for certificate" },
    { id: "certificate", name: "View certificate" },
  ];

  const handleSectionClick = (sectionId) => {
    setActiveSection(sectionId);

    
      navigate(`/user/${sectionId}`);
  

    if (onItemClick) {
      onItemClick();
    }
  };
  // const handleSectionClick = (sectionId) => {
  //   setActiveSection(sectionId);

  //   if (sectionId === "view-certificate") {
  //     const url = `/certificate/${assessment_id}`;
  //     window.open(url, "_blank");
  //   } else {
  //     navigate(`/user/${sectionId}`);
  //   }

  //   if (onItemClick) {
  //     onItemClick();
  //   }
  // };

  return (
    // Add a conditional "open" class if isOpen is true
    <div className={`sidebar ${isOpen ? "open" : ""}`}>
      <ul>
        {sections.map((section) => (
          <li
            key={section.id}
            className={activeSection === section.id ? "active" : ""}
            onClick={() => handleSectionClick(section.id)}
          >
            {section.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
